import type { SwitchProps as AntdSwitchProps } from 'antd';
import { Switch as AntdSwitch, ConfigProvider } from 'antd';

import FieldsContainer from '../fields/fields-container';
import { defaultInputTheme } from '../fields/ourConfigs';

interface SwitchProps extends AntdSwitchProps {
  error?: string;
  label?: string;
}

function Switch({ error, label, ...props }: SwitchProps) {
  return (
    <FieldsContainer label={label} error={error}>
      <ConfigProvider theme={defaultInputTheme}>
        <AntdSwitch {...props} />
      </ConfigProvider>
    </FieldsContainer>
  );
}

export default Switch;
